module.exports = __webpack_public_path__ + "img/5-l.ab47d47d.png";